export default "__VITE_PUBLIC_ASSET__3e47e1fe__"